import React from 'react'
import Header from './components/home/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Skills from './components/skills/Skills'
import Projects from './components/projects/Projects'
import Experiences from './components/experiences/Experiences'
import Educations from './components/educations/Educations'
import Services from './components/services/Services'
import Certificates from './components/certificates/Certitificates'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {
  return (
    <>
    <Header/>
    <Nav/>
    <About/>
    <Skills/>
    <Projects/>
    <Experiences />
    <Educations />
    <Services />
    <Certificates />
    <Contact />
    <Footer />
    </>
  
  )
}

export default App
